import { getCenter } from "../../../utils"
import { VLandLocationDataRemote, VLocationDataRemote } from "../api/location-data"
import { VLandLocationData, VLocationData } from "../common"

export function mapVLocationRemoteToDomain(remote: VLocationDataRemote): VLocationData {
  return {
    city: remote.city_name,
    country: remote.country_name,
    zipCode: remote.zip_code,
    address: remote.address,
    locationGrade: remote.location_grade_name,
    latitude: Number(remote.latitude),
    longitude: Number(remote.longitude),
    locationSurrounding: remote.location_surrounding,
    timezoneOffset: remote.timezoneOffset
  }
}

export function mapVLandLocationRemoteToDomain(remote: VLandLocationDataRemote): VLandLocationData {
  const center = getCenter(remote.points)
  return {
    city: remote.city_name,
    country: remote.country_name,
    zipCode: remote.zip_code,
    address: remote.address,
    locationGrade: remote.location_grade_name,
    latitude: Number(remote.latitude),
    longitude: Number(remote.longitude),
    points: remote.points.map(p => ({ lat: Number(p.lat), lng: Number(p.lng) })).filter(p => p.lat != null && p.lng != null),
    timezoneOffset: remote.timezoneOffset
  }
}